import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Maintenance from '../pages/Maintenance';

export default function MaintenanceGate({ children }) {
  const [state, setState] = useState({ loading: true, active: false, message: '' });

  useEffect(() => {
    let cancelled = false;

    const fetchStatus = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/public/maintenance-status`
        );
        if (!cancelled) {
          setState({
            loading: false,
            active: Boolean(data.maintenanceMode),
            message: data.message || '',
          });
        }
      } catch {
        if (!cancelled) {
          setState({ loading: false, active: false, message: '' });
        }
      }
    };

    fetchStatus();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-slate-50">
        <div className="text-lg text-gray-600">Chargement...</div>
      </div>
    );
  }

  if (state.active) {
    return <Maintenance message={state.message} />;
  }

  return children;
}
